import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-grid p-ai-center" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-text-uppercase kn-truncated" }
const _hoisted_9 = { class: "kn-flex p-d-flex p-flex-row p-m-2" }
const _hoisted_10 = {
  key: 0,
  class: "kn-flex p-d-flex p-flex-row p-m-1"
}
const _hoisted_11 = { class: "p-m-1" }
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = { class: "kn-flex p-d-flex p-flex-row p-jc-between p-ml-auto" }
const _hoisted_14 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Editor = _resolveComponent("Editor")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionMetadataDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.metadata')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: !_ctx.canModify,
          onClick: _ctx.save
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.metadata)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_ctx.metadata.generalMetadata.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("h2", null, _toDisplayString(_ctx.$t('common.documentDetails')), 1),
                  _createVNode("div", _hoisted_3, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metadata.generalMetadata, (meta, index) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                        (meta.value && index !== _ctx.metadata.generalMetadata.length - 1)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: { 'p-col-4': index !== 3, 'p-col-12': index === 3 }
                            }, [
                              _createVNode("label", _hoisted_4, _toDisplayString(meta.name), 1),
                              (index !== 3)
                                ? (_openBlock(), _createBlock(_component_InputText, {
                                    key: 0,
                                    class: "kn-material-input p-inputtext-sm",
                                    modelValue: meta.value,
                                    "onUpdate:modelValue": ($event: any) => (meta.value = $event),
                                    disabled: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createBlock(_component_Textarea, {
                                    key: 1,
                                    modelValue: meta.value,
                                    "onUpdate:modelValue": ($event: any) => (meta.value = $event),
                                    rows: "2",
                                    disabled: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.metadata.shortText.length > 0 || _ctx.metadata.longText.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("h2", null, _toDisplayString(_ctx.$t('documentExecution.main.customMetadata')), 1),
                  _withDirectives(_createVNode("div", _hoisted_6, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metadata.shortText, (meta, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: "p-col-4"
                      }, [
                        _createVNode("label", _hoisted_7, _toDisplayString(meta.name), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input p-inputtext-sm",
                          modelValue: meta.value,
                          "onUpdate:modelValue": ($event: any) => (meta.value = $event),
                          disabled: !_ctx.canModify
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.metadata.shortText.length > 0]
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.metadata.shortText.length > 0 || _ctx.metadata.longText.length > 0) && _ctx.metadata.longText.length > 0)
              ? (_openBlock(), _createBlock(_component_TabView, {
                  key: 2,
                  scrollable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metadata.longText, (meta, index) => {
                      return (_openBlock(), _createBlock(_component_TabPanel, { key: index }, {
                        header: _withCtx(() => [
                          _createVNode("span", _hoisted_8, _toDisplayString(meta.name), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Editor, {
                            modelValue: meta.value,
                            "onUpdate:modelValue": ($event: any) => (meta.value = $event),
                            readonly: !_ctx.canModify,
                            editorStyle: _ctx.documentExecutionMetadataDialogDescriptor.editor.style
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "editorStyle"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", null, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t('common.attachments')), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metadata.file, (meta, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "p-d-flex p-flex-row p-ai-center"
                }, [
                  _createVNode("div", _hoisted_9, [
                    (meta.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode(_component_InputText, {
                            class: "kn-material-input p-inputtext-sm",
                            modelValue: meta.value.fileName,
                            "onUpdate:modelValue": ($event: any) => (meta.value.fileName = $event),
                            disabled: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_InputText, {
                            class: "kn-material-input p-inputtext-sm",
                            modelValue: meta.value.saveDate,
                            "onUpdate:modelValue": ($event: any) => (meta.value.saveDate = $event),
                            disabled: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("label", _hoisted_12, _toDisplayString(meta.name), 1),
                      _createVNode(_component_KnInputFile, {
                        ref: '' + meta.id,
                        id: '' + meta.id,
                        changeFunction: _ctx.uploadFile,
                        visibility: true
                      }, null, 8, ["id", "changeFunction"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    (_ctx.canModify)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "kn-button kn-button--primary document-execution-metadata-dialog-upload-button",
                          onClick: ($event: any) => (_ctx.uploadMetaFile(meta))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.upload')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode(_component_Button, {
                      class: "kn-button kn-button--primary document-execution-metadata-dialog-upload-button",
                      onClick: ($event: any) => (_ctx.downloadFile(meta))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.download')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]), [
                      [_vShow, _ctx.canModify && meta.value]
                    ]),
                    (_ctx.canModify)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          class: "kn-button kn-button--primary document-execution-metadata-dialog-upload-button",
                          onClick: ($event: any) => (_ctx.cleanFile(meta))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.clean')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.metadata.file.length > 0]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}